import { RouteComponentProps } from '@reach/router';
import { PageHero } from '../../components/pageHero/PageHero';
import Page from '../../components/shared/Page';
import { UpdateProfileForm } from './UpdateProfileForm';
import placeholderProfileImage from '../../images/Icon_Profile_01.png';
import profileHeroImage from '../../images/Img_Profile.png';
import React, { useCallback, useEffect, useState } from 'react';
import { IProfileInfo } from './models';
import { ProfileApi } from 'api/profileAPI';
import MfaSettings from './MfaSettings';

export const Profile: React.FC<RouteComponentProps> = () => {
  const [updateIsOpen, setUpdateIsOpen] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [profileDetails, setProfileDetails] = useState<IProfileInfo | null>(
    null
  );

  const loadProfileDetails = useCallback(async () => {
    const result = await ProfileApi.getProfileDetails();
    if (result?.data) {
      setProfileDetails(result.data);
    }
  }, []);

  useEffect(() => {
    loadProfileDetails();
  }, [loadProfileDetails]);

  const updateEmailPreferences = async (emailAlertValue: boolean) => {
    if (!profileDetails) return;
    setSubmitting(true);
    const result = await ProfileApi.updateEmailPreferences({
      bEmailAlerts: emailAlertValue,
    });
    if (result.data) {
      setSubmitting(false);
    }

    if (result.error) {
      setSubmitting(false);
      const newState = {
        ...profileDetails,
        bEmailAlerts: !emailAlertValue,
      };
      setProfileDetails(newState);
    }
  };

  const toggleEmailAlerts = (
    e: React.MouseEvent<HTMLLabelElement, MouseEvent>
  ) => {
    e.preventDefault();

    const emailAlertValue = !profileDetails?.bEmailAlerts;

    if (!profileDetails) return;
    const newState = {
      ...profileDetails,
      bEmailAlerts: emailAlertValue,
    };
    setProfileDetails(newState);

    updateEmailPreferences(emailAlertValue);
  };

  const handleMenuClose = () => {
    setUpdateIsOpen(false);
  };

  return (
    <Page>
      <div className="PageContent ProfilePage">
        <PageHero
          title={`${profileDetails?.firstName ?? ''} ${
            profileDetails?.lastName ?? ''
          }`}
          image={profileHeroImage}
        />
        <div className="WidthContent">
          <div className="ProfileSection Top">
            <div className="FlexLeft">
              <div className="ProfileImageContainer">
                <img src={placeholderProfileImage} alt="Profile" />
              </div>
              <div className="ProfileInfo">
                <h5 className="Name">{`${profileDetails?.firstName ?? ''} ${
                  profileDetails?.lastName ?? ''
                }`}</h5>
                <p className="Email">{profileDetails?.emailAddress ?? ''}</p>
                <p className="Password">••••••••••••••</p>
              </div>
            </div>
            <button
              className="Btn BtnLightOrange UpdateButton"
              onClick={() => setUpdateIsOpen(true)}
              disabled={profileDetails ? false : true}
            >
              Update details
            </button>
          </div>
          <label
            className={`ProfileSection CheckboxSection ${
              profileDetails?.bEmailAlerts ? 'Checked' : ''
            }`}
            onClick={toggleEmailAlerts}
          >
            <div className="FormBox ">
              <div className="Checkbox">
                <input
                  type="checkbox"
                  checked={profileDetails?.bEmailAlerts}
                  disabled={
                    profileDetails ? (isSubmitting ? true : false) : true
                  }
                />
                <div className="CustomInput Black">Receive email alert</div>
              </div>
            </div>
          </label>

          {profileDetails && (
            <MfaSettings
              profileDetails={profileDetails}
              onChanged={loadProfileDetails}
            />
          )}
        </div>

        {/* Update profile form */}

        {profileDetails && updateIsOpen && (
          <UpdateProfileForm
            updateIsOpen={updateIsOpen}
            handleMenuClose={handleMenuClose}
            profileDetails={profileDetails}
            setProfileDetails={setProfileDetails}
          />
        )}
      </div>
    </Page>
  );
};
